<style lang="scss" scoped>
.location-card {
    display: block;
    position: relative;

    .xsmall {
        line-height: 1.2;
    }

    .image-wrapper {
        position: relative;
        overflow: hidden;
        border-radius: 4px;

        img {
            position: absolute;
            top: 0px;
            bottom: 0px;
            left: 0px;
            right: 0px;
            width: 100%;
            height: 100%;

            object-fit: cover;
            font-family: "object-fit: cover;";
            transition: transform 0.15s;
        }
    }

    &:hover {
        img {
            transform: scale(1.1);
        }
    }
}
</style>

<template>
    <a
        v-if="location"
        class="location-card w-100 h-100 text-decoration-none text-dark"
        :href="route('nl.location', { slug: location.slug })"
    >
        <div
            class="image-wrapper"
            :style="{
                'padding-top': ratio
                    ? `${(arHeight / arWidth) * 100}%`
                    : '240px'
            }"
        >
            <img
                v-if="location.acf && location.acf.image"
                :src="location.acf.image.sizes.large"
                :alt="location.title.rendered"
                class="w-100"
            />
        </div>

        <p class="mb-0 mt-8 small" v-html="location.title.rendered"></p>
        <template v-if="location.acf && location.acf.bullet_points">
            <p
                class="xsmall"
                v-for="(bulletPoint, index) in location.acf.bullet_points"
                :key="index"
            >
                {{ bulletPoint.bullet_point }}
            </p>
        </template>
        <div
            v-if="location.location_categories && location.location_categories.length > 0"
            class="tag-row mt-12"
            ref="categories"
            :key="location.location_categories.length"
        >
            <div
                ref="tags"
                class="tag-col"
                v-for="(category, index) in location.location_categories"
                :key="index"
            >
                <div
                    class="tag tag-accent-light tag-xs"
                    v-html="category.name"
                />
            </div>
        </div>
    </a>
</template>

<script>
export default {
    name: "elements.location-card",

    props: {
        location: {
            type: Object,
            required: false
        },
        ratio: {
            type: [String, Boolean],
            required: false
        }
    },

    computed: {
        arWidth() {
            if (!this.ratio) return 0;
            return this.ratio.split(":")[0];
        },
        arHeight() {
            if (!this.ratio) return 0;
            return this.ratio.split(":")[1];
        }
    }
};
</script>
